export const WORK_ASSIGNMENT_ERROR_LABELS = {
	crewMemberAlreadyAssigned: 'Crew member already assigned',
	tooManyAssignmentsForActivityType: 'Too many assignments for this activity type',
	workAssignmentAlreadyUpdated: 'Assignmnent already updated',
	statusCantBeUpdated: "Status can't be updated",
	actualStatusAssignedBeforeAssignmentCompletion:
		'It’s not possible to set to “Actual” a work assignment that was not completed yet',
	invalidActivityType: 'Activity type is not allowed for this assignment',
	shiftTimeTooLong: 'Resulting shift is too long for this crew member',
};

export const createAssignmentErrorNotification = (fromStationName, toStationName, errorList) => {
	return {
		label: [...new Set(errorList)].map((error) => WORK_ASSIGNMENT_ERROR_LABELS[error]),
		header: `Issue with assignment from ${fromStationName} to ${toStationName}:`,
		appearance: 'danger',
	};
};
